import React, { useEffect, useState } from "react";
import { AppButton } from "site/ui";
import styled from "styled-components";
import { ICourse, IModule, IUserCourse, IUserQuiz } from "utils/types";


const QuizCard = styled.div`
  background: white;
  border-radius: 10px;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  gap: 35px;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 15px;
  }
`;

const QuizInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  flex: 1;
`;

const QuizBadge = styled.div`
  background-color: #5575f7;
  color: white;
  font-size: 12px;
  font-weight: 500;
  padding: 4px 10px;
  border-radius: 20px;
  width: fit-content;
`;

const QuizTitle = styled.h3`
  margin: 0;
  font-size: 16px;
  font-weight: 600;
`;

const QuizDetail = styled.div`
  display: flex;
  gap: 5px;
  align-items: center;
  font-size: 14px;
  color: #6c757d;
  flex: 1;
`;

const Label = styled.span`
  font-weight: 500;
`;

const Value = styled.span`
  color: #6c757d;
`;

const ProgressContainer = styled.div`
  height: 8px;
  background-color: #e9ecef;
  border-radius: 4px;
  overflow: hidden;
  flex: 1;
  align-items: center;
  display: flex;
`;

const ProgressBar = styled.div<{ progress: number }>`
  height: 100%;
  width: ${({ progress }) => `${progress}%`};
  background-color: ${({ progress }) =>
    progress === 100 ? "#28a745" : "#5575f7"};
  border-radius: 4px;
  transition: width 0.3s ease;
`;


export interface AdminUserProgressCardProps {
  course?: ICourse;
  data: (IUserQuiz|IUserCourse) & { isUserQuiz: boolean };
  courseId: string;
  onGetCourse: (courseId: string) => Promise<ICourse|undefined>;
  onGetCourseModuleCount: (courseModule: Partial<IModule>) => Promise<number>;
 }

export const AdminUserProgressCard: React.FC<AdminUserProgressCardProps> = ({
  courseId, course: initCourse,
  data, onGetCourse, onGetCourseModuleCount,
}) => {
  const [course, setCourse] = useState<ICourse|undefined>(initCourse);
  const [moduleCount, setModuleCount] = useState(0);
  

  const isUserQuiz = data.isUserQuiz;
  let userQuiz:IUserQuiz|undefined;
  let userCourse:IUserCourse|undefined;
  let progress = 0;
  if(isUserQuiz){
    userQuiz = (data as IUserQuiz);
    progress = 100;
  }else {
    userCourse = (data as IUserCourse);
    progress = moduleCount === 0 ? 0 : (userCourse?.completedCourseModuleIds?.length || 0) * 100 / moduleCount;
  }

  useEffect(() => {
    if(courseId && !initCourse){
      onGetCourse(courseId).then(setCourse)
    }
  }, [courseId, JSON.stringify(initCourse)])
  useEffect(() => {

    if(courseId){
      onGetCourseModuleCount({
        courseId
      }).then(setModuleCount)
    }
  }, [courseId])
  return <QuizCard>
    <QuizInfo>
      <QuizBadge>{isUserQuiz ? "Quiz" : "Course"}</QuizBadge>
      <QuizTitle>{course?.title || ""}</QuizTitle>
      <div style={{display: "flex", gap: "10px", flexDirection: "column"}}>
      <QuizDetail>
          <Label>Progress:</Label>
          <ProgressContainer>
            <ProgressBar progress={progress} />
          </ProgressContainer>
      </QuizDetail>
      {userQuiz && (<>
          <QuizDetail>
              <Label>Score:</Label>
              <Value>{userQuiz?.score || 0} / {userQuiz?.totalScore || 0}</Value>
          </QuizDetail>
          <QuizDetail>
              <Label>Quiz mode:</Label>
              <Value>{userQuiz.quizMode}</Value>
          </QuizDetail>
        </>)}
      </div>
    </QuizInfo>
  </QuizCard>
};